import React from 'react';

import {useStore} from 'effector-react';
import {useTranslation} from 'react-i18next';

import {Button, ButtonVariant} from 'components/ui-kit/Button';
import {Modal} from 'components/ui-kit/Modal';

import {$doesInvoiceExist} from 'models/documents/invoices/common';

import {ModalContent, ModalMessage, ModalButtons} from './styled';

interface Props {
    show: boolean;
    onConfirm: () => void;
    onCancel: () => void;
    doesDocumentExist?: boolean;
    translationPath?: string;
}

export const ConfirmNavigationModal: React.FC<Props> = ({
    show,
    onConfirm,
    onCancel,
    doesDocumentExist,
    translationPath = 'pages.documents.invoices',
}) => {
    const {t} = useTranslation();
    const doesInvoiceExist = useStore($doesInvoiceExist);
    const documentExists = doesDocumentExist ?? doesInvoiceExist;

    const existingPath = `${translationPath}.confirmNavigationModalExisting`;
    const newPath = `${translationPath}.confirmNavigationModalNew`;
    const title = documentExists ? t(`${existingPath}.title`) : t(`${newPath}.title`);
    const message = documentExists ? t(`${existingPath}.message`) : t(`${newPath}.message`);
    const confirm = documentExists ? t(`${existingPath}.confirm`) : t(`${newPath}.confirm`);
    const cancel = documentExists ? t(`${existingPath}.cancel`) : t(`${newPath}.cancel`);
    return (
        <Modal
            show={show}
            onClose={onCancel}
            closable={false}
            hideCloseButton={true}
            modalWidth={0}
            title={title}
        >
            <ModalContent>
                <ModalMessage>{message}</ModalMessage>
                <ModalButtons>
                    <Button variant={ButtonVariant.Outline} onClick={onConfirm}>
                        {confirm}
                    </Button>
                    <Button variant={ButtonVariant.Normal} onClick={onCancel}>
                        {cancel}
                    </Button>
                </ModalButtons>
            </ModalContent>
        </Modal>
    );
};
